export interface Guest {
  id: number;
  firstName: string;
  lastName: string | null;
  message?: string | null;
  messageForCaterer?: boolean;
  tableAssignment?: {
    tableName: string;
    seatIndex: number;
  } | null;
  rsvps?: Array<{
    attending: boolean;
  }>;
}

export const TABLES = {
  honor: { name: 'Table d\'honneur', seats: 24, type: 'honor' as const },
  table1: { name: 'Table 1', seats: 34, type: 'regular' as const },
  table2: { name: 'Table 2', seats: 34, type: 'regular' as const },
  table3: { name: 'Table 3', seats: 34, type: 'regular' as const },
  table4: { name: 'Table 4', seats: 34, type: 'regular' as const },
};
